var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45318 10.0467C6.51434 10.1355 6.59618 10.2081 6.69164 10.2583C6.7871 10.3085 6.89333 10.3347 7.00118 10.3347C7.10903 10.3347 7.21526 10.3085 7.31072 10.2583C7.40618 10.2081 7.48802 10.1355 7.54918 10.0467L13.5492 1.37999C13.6186 1.28002 13.6594 1.16294 13.6669 1.04146C13.6745 0.919971 13.6487 0.798733 13.5922 0.690914C13.5357 0.583094 13.4507 0.492817 13.3465 0.42989C13.2423 0.366963 13.1229 0.333793 13.0012 0.333985H1.00118C0.879741 0.334487 0.760737 0.368083 0.656966 0.431161C0.553194 0.494238 0.46858 0.58441 0.412224 0.691981C0.355868 0.799551 0.329902 0.920449 0.337118 1.04167C0.344334 1.1629 0.384459 1.27986 0.453178 1.37999L6.45318 10.0467Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownVector);
export default __webpack_public_path__ + "static/media/DownVector.25c5da57953783c3200841d1709e3d65.svg";
export { ForwardRef as ReactComponent };